var exports = {
  "ft": "xcc377c0b--3a00a1--comparison-banner",
  "DD": "xcc377c0b--3a00a1--title",
  "Sl": "xcc377c0b--3a00a1--image",
};

module.exports = exports;
